// Story Library presentation gate only. Writer Studio and backend remain authoritative.
export function isSoloStoryline(story) {
  const mode = String(story?.writingMode || story?.mode || "").trim().toLowerCase();
  return mode.includes("solo");
}

const norm = (input) => typeof input === "string" ? input.trim() : "";

export function canOfferWriterRoom(story, viewer) {
  // Keep established Collaborative and Group writer-room behaviour.
  if (!isSoloStoryline(story)) return true;
  if (!viewer?.isAuthenticated || !viewer?.user) return false;

  const storyOwnerId = norm(
    story?.authorProfile?.id ||
    story?.authorProfile?._id ||
    (typeof story?.author === "object" ? story?.author?.id || story?.author?._id : "") ||
    story?.authorId ||
    story?.createdById ||
    story?.ownerId
  );
  const sessionId = norm(viewer.user?.id || viewer.user?._id);
  if (storyOwnerId && sessionId) return storyOwnerId === sessionId;

  // Legacy records may have no IDs. Match verified usernames, not display names.
  const storyOwnerUsername = norm(
    story?.authorProfile?.username ||
    (typeof story?.author === "object" ? story?.author?.username : "") ||
    story?.authorUsername ||
    story?.createdByUsername ||
    story?.ownerUsername ||
    story?.createdBy
  ).toLowerCase();
  const sessionUsername = norm(viewer.user?.username || viewer.username).toLowerCase();
  return !!storyOwnerUsername && !!sessionUsername && storyOwnerUsername === sessionUsername;
}
